import React, { useState } from "react";
import Fade from 'react-reveal/Fade';
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { LOGIN_STATES } from "../../data/Login/LoginStates";

// Set axios defaults outside the component
axios.defaults.withCredentials = true;
const FORGOT_VIEW = 2;

const SignupForm = ({
    signupEmail = "",
    signupPassword = "",
    signupPasswordConfirm = "",
    fName = "",
    lName = "",
    updateReducerState,
    setLoginState
}) => {
    // --- State ---
    const [email, setEmail] = useState(signupEmail);
    const [password, setPassword] = useState(signupPassword);
    const [passwordConfirm, setPasswordConfirm] = useState(signupPasswordConfirm);
    const [firstName, setFirstName] = useState(fName);
    const [lastName, setLastName] = useState(lName);
    const [invalidPress, setInvalidPress] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    // --- Validation Helpers ---
    const verifyEmail = () => email.includes('@') && email.includes('.');

    const verifyPassword = (pw) => {
        const hasSymbol = /[!@#$%^&*()\-=_+[\]"';:,.<>?`~]/.test(pw);
        const hasNumber = /[0-9]/.test(pw);
        const hasCaps = /[A-Z]/.test(pw);

        if (!hasSymbol || !hasNumber || !hasCaps) {
            setErrorMsg("Password Must Contain 1 Symbol, Uppercase Letter, and Number!");
            setInvalidPress(true);
            return false;
        }
        return true;
    };

    // --- Event Handlers ---
    const toggleInvalidPress = () => {
        setInvalidPress(true);
        if (firstName.length === 0 || firstName.length > 50) {
            setErrorMsg("Invalid First Name Length!");
        } else if (lastName.length === 0 || lastName.length > 50) {
            setErrorMsg("Invalid Last Name Length!");
        } else if (email.length === 0 || email.length > 50 || !verifyEmail()) {
            setErrorMsg("Invalid Email Length or Format!");
        } else if (password.length === 0 || password.length > 50) {
            setErrorMsg("Invalid Password Length!");
        } else if (password !== passwordConfirm) {
            setErrorMsg("Passwords Must Match!");
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (verifyPassword(password)) {
            axios.post("/api/user", {
                withCredentials: true,
                data: { firstName, lastName, email, password },
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }).then((res) => {
                if (res.data.status) {
                    window.location.reload(false);
                } else {
                    setInvalidPress(true);
                    setErrorMsg(res.data.message);
                }
            });
        }
    };

    // --- Form Logic ---
    const isFormValid = (
        firstName.length > 0 && firstName.length < 50 &&
        lastName.length > 0 && lastName.length < 50 &&
        password.length > 0 && password.length < 50 &&
        verifyEmail() &&
        password === passwordConfirm
    );

    return (
        <>
            <div className="login-box">
            <h1 className="header">Signup for Account</h1>
                <form onSubmit={handleSubmit}>

                    <label>
                        First Name: {firstName.length === 0 ? <i className="fa-thin fa-asterisk red-asterisk" /> : <i className="fa-solid fa-check green-check" />}
                        <InputText value={firstName} onChange={(e) => {
                            setFirstName(e.target.value);
                            setInvalidPress(false);
                            updateReducerState('firstName', e.target.value);
                        }} />
                    </label>

                    <label>
                        Last Name: {lastName.length === 0 ? <i className="fa-thin fa-asterisk red-asterisk" /> : <i className="fa-solid fa-check green-check" />}
                        <InputText value={lastName} onChange={(e) => {
                            setLastName(e.target.value);
                            setInvalidPress(false);
                            updateReducerState('lastName', e.target.value);
                        }} />
                    </label>

                    <label>
                        Email: {verifyEmail() ? <i className="fa-solid fa-check green-check" /> : <i className="fa-thin fa-asterisk red-asterisk" />}
                        <InputText value={email} onChange={(e) => {
                            setEmail(e.target.value);
                            setInvalidPress(false);
                            updateReducerState('signupEmail', e.target.value);
                        }} />
                    </label>

                    <label>
                        Password: {password.length === 0 ? <i className="fa-thin fa-asterisk red-asterisk" /> : <i className="fa-solid fa-check green-check" />}
                        <Password type="password" name="password" value={password} toggleMask={true} onChange={(e) => {
                            setPassword(e.target.value);
                            setInvalidPress(false);
                            updateReducerState('signupPassword', e.target.value);
                        }} />
                    </label>

                    <label>
                        Confirm Password: {(password.length > 0 && password === passwordConfirm) ? <i className="fa-solid fa-check green-check" /> : <i className="fa-thin fa-asterisk red-asterisk" />}
                        <Password value={passwordConfirm} onChange={(e) => {
                            setPasswordConfirm(e.target.value);
                            setInvalidPress(false);
                            updateReducerState('signupPasswordConfirm', e.target.value);
                        }} />
                    </label>

                    <Fade bottom when={invalidPress}>
                        {invalidPress && <h3 className="error-text">{errorMsg}</h3>}
                    </Fade>

                    <div className="login-buttons">
                        <div>
                            {isFormValid ? (
                                <button className="login-button approved-button" type="submit">
                                    Create Account <i className="fa-solid fa-check" />
                                </button>
                            ) : (
                                <button className="login-button denied-button" type="button" onClick={toggleInvalidPress}>
                                    Create Account <i className="fa-thin fa-x" />
                                </button>
                            )}
                        </div>

                        <div>
                            <button
                                className="login-button pending-button"
                                type="button"
                                onClick={() => setLoginState(LOGIN_STATES.FORGOT)}
                            >
                                Forgot Password? <i className="fa-solid fa-thought-bubble"></i>
                            </button>
                        </div>
                    </div>
                </form>
                <p>Already Have an Account?</p>
            <button className="login-toggle-button all-button"
                type="button"
                onClick={() => setLoginState(LOGIN_STATES.LOGIN)}>
                Login <i class="fa-solid fa-pen"></i>
            </button>
            </div>


        </>
    );
};

export default SignupForm;